import { limitFill } from "@cloudinary/transformation-builder-sdk/actions/resize";
import { autoGravity } from "@cloudinary/transformation-builder-sdk/qualifiers/gravity";
import { Button, Card } from "@ttc3k/trekker";
import { EnumListType, OperatorManyQuery } from "gql/generated";
import { Check } from "iconoir-react";
import { useTranslation } from "react-i18next";
import { CloudinaryImage } from "shared/components";
import { getMultilingualString } from "shared/utils";
import { isLandscape } from "shared/utils/isLandscape";
import { Box, Flex } from "styled-system/jsx";

type ListOperatorCardProps = {
  operator: OperatorManyQuery["operatorMany"][0];
  listType: EnumListType;
  isAdded?: boolean;
  onAddOperator?: () => void;
};

export const ListOperatorCard = ({
  operator,
  listType,
  isAdded,
  onAddOperator,
}: ListOperatorCardProps) => {
  const { t } = useTranslation();
  return (
    <Card.Surface bg={"white"}>
      <Card.Body>
        <Card.BodyContent alignItems={"center"}>
          <Flex alignItems={"center"} gap={"250"}>
            <Box
              width={"60px"}
              height={"60px"}
              bgColor={
                operator.images && operator.images.length > 0
                  ? "transparent"
                  : "icon.disabled"
              }
              borderRadius={"100"}
            >
              {operator.images && operator.images.length > 0 && (
                <CloudinaryImage
                  image={operator.images[0]}
                  imageStyleProps={{
                    aspectRatio: "square",
                    objectFit: "cover",
                    borderRadius: "100",
                    width: "60px",
                    height: "60px",
                  }}
                  resize={
                    isLandscape(operator.images[0])
                      ? limitFill().height(60).gravity(autoGravity())
                      : limitFill().width(60).gravity(autoGravity())
                  }
                />
              )}
            </Box>
            <Card.Title
              mainText={getMultilingualString(operator.name)}
              subText={t("core:OPERATOR")}
            />
          </Flex>
          {listType === EnumListType.Manual && (
            <Button
              size={"sm"}
              mode={isAdded ? "dark" : "light"}
              visual={isAdded ? "success" : "primary"}
              Icon={isAdded ? Check : undefined}
              onClick={onAddOperator}
              isIconRightAligned
            >
              {t(`core:${isAdded ? "ADDED" : "ADD"}`)}
            </Button>
          )}
        </Card.BodyContent>
      </Card.Body>
    </Card.Surface>
  );
};
